import React from "react";
import PageTitle from "../components/PageTitle";
import ScheduleSection from "../Schedule";
import PageCarousel from "./PageCarousels";
import YouTubeVideo from "./videoplayer";

const Buybacks = () => {
  PageTitle(
    "Buybacks - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div>
      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2>BUYBACKS</h2>
            </div>
            <div class="col-12">
              <a href="">Home</a>
              <a href="">Buybacks</a>
            </div>
          </div>
        </div>
      </div>
      <PageCarousel collectionName="buybacks_banner" />

      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/buybackcontent.png" alt="Image" />
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                <h2>BUYBACKS</h2>
              </div>
              <div class="about-text">
                <h3>
                  {" "}
                  <p>
                    28 Day Buyback service – No need to sell your goods forever
                  </p>
                </h3>
                <p>
                  {" "}
                  You never know what's around the corner - an unexpected bill,
                  boiler leak or a problem with your washing machine, and always
                  at the most inconvenient time! There are many reasons you may
                  need money at short notice - money that you don't necessarily
                  have at this instant.With our 28-day buyback service, you can
                  sell your items for instant cash and still have the chance to
                  buy them back within 28 days!
                </p>
                <h3>
                  <p>
                    We’ll consider most things in a good condition TV’s, games,
                    consoles, mobiles, laptops, jewellery, cameras, hi-fi’s,
                    power tools, musical instruments and anything else of value.
                  </p>
                </h3>
                <ul>
                  <li>Bring your item(s) into our store for a Free Quote</li>
                  <li>We securely store the items</li>
                  <li>
                    Come back within 28 DAYS and pay the amount we originally
                    gave you plus a small fee* and collect your item!
                  </li>
                </ul>
                <h3>
                  <p>
                    <p>TERMS AND CONDITIONS APPLY – ID REQUIRED</p>
                  </p>
                </h3>
                <a
                  class="btn"
                  href="https://api.whatsapp.com/send?phone=447871092759"
                >
                  GET A FREE QUOTE FOR YOUR ITEM
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <img class="centered-img" src="img/buybackdidyouknow.png" alt="Image" />
      </div>
      <YouTubeVideo />
      <div class="feature wow fadeInUp" data-wow-delay="0.1s">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                <div class="feature-text">
                  <h3>WE BUY</h3>
                  <p>We Buy your items for INSTANT CASH</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                <div class="feature-text">
                  <h3>WE HOLD</h3>
                  <p>
                    We hold your item for up 28 days (with the option to renew)
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                <div class="feature-text">
                  <h3>YOU BUY BACK</h3>
                  <p>
                    You buy back your item for the price we paid you, plus a
                    small fee.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ScheduleSection />
    </div>
  );
};

export default Buybacks;
